<header class="app-header">
  <img src="/assets/logosemfundo.svg" alt="Logo" width="250" height="auto">
</header>
<main class="page-container">
  <router-outlet></router-outlet>
</main>
